export const enum StaffRoleId {
	ProgramExperience = 1,
	VolunteerRecruiter = 2,
	VolunteerCoordinator = 3,
	EnrollmentCoordinator = 4,
	ProgramFacilitator = 5
}

export enum StaffRole {
	ProgramExperience = 'Program Experience',
	VolunteerRecruiter = 'Volunteer Recruiter',
	VolunteerCoordinator = 'Volunteer Coordinator',
	EnrollmentCoordinator = 'Enrollment Coordinator',
	ProgramFacilitator = 'Program Facilitator'
}